import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import VariableSalaryModalBase from "../VariableSalaryModalBase.vue";
import priceFormatter from "@/utility/priceFormatter";
import Absence from "../Absence.vue";
import LevelCalculationBasis from "./LevelCalculationBasis.vue";
import LevelCalculationEquaction from "./LevelCalculationEquaction.vue";
export default Vue.extend({
    props: {
        selectedDate: String,
        salaryRow: {},
        salaryRowDetails: {},
    },
    components: {
        VariableSalaryModalBase,
        LevelCalculationBasis,
        LevelCalculationEquaction,
        Absence,
    },
    filters: {
        numberToSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK();
        },
    },
    computed: {
        ...mapGetters("variableSalaryModal", ["hoveredVariable"]),
        variableSalaryClass() {
            const base = ["math-text", "h1", "cursor-default"];
            if (this.hoveredVariable === "Variable salary") {
                base.push("hovered");
            }
            return base;
        },
    },
    methods: {
        ...mapActions("variableSalaryModal", ["setHoveredVariable"]),
        hoveredClass(target) {
            if (target === this.hoveredVariable) {
                return "hovered";
            }
        },
    },
});
